module.exports = __webpack_public_path__ + "img/launchpad-rocket-moonriver.a6c8e956.svg";